import { useParams } from 'react-router-dom';
import { isNumericProblemIdParam } from '../utils/problemUrls.ts';
import LegacyProblemRedirect from './LegacyProblemRedirect.tsx';
import ProblemsList from './ProblemsList.tsx';

/**
 * /problems и /problems/:topicOrId — один экземпляр списка (без remount при смене темы),
 * либо редирект со старого /problems/:id.
 */
function ProblemsTopicOrLegacy() {
  const { topicOrId } = useParams<{ topicOrId?: string }>();
  if (topicOrId && isNumericProblemIdParam(topicOrId)) {
    return <LegacyProblemRedirect problemId={topicOrId} />;
  }
  return <ProblemsList />;
}

export default ProblemsTopicOrLegacy;
